import _regeneratorRuntime from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * @internal
 */
export function getHeaderName() {
  return "x-ms-useragent";
}

function getBrowserInfo(userAgent) {
  var browserRegexes = [{
    name: "Firefox",
    regex: /Firefox\/([\d.]+)/
  }, {
    name: "Safari",
    regex: /Version\/([\d.]+).*Safari/
  }];

  for (var _i = 0, _browserRegexes = browserRegexes; _i < _browserRegexes.length; _i++) {
    var browser = _browserRegexes[_i];
    var match = userAgent.match(browser.regex);

    if (match) {
      return {
        brand: browser.name,
        version: match[1]
      };
    }
  }

  return undefined;
}

function getBrandVersionString(brands) {
  var brandOrder = ["Google Chrome", "Microsoft Edge", "Opera", "Brave", "Chromium"];

  var _loop = function _loop() {
    var brand = _brandOrder[_i2];
    var foundBrand = brands.find(function (b) {
      return b.brand === brand;
    });

    if (foundBrand) {
      return {
        v: foundBrand
      };
    }
  };

  for (var _i2 = 0, _brandOrder = brandOrder; _i2 < _brandOrder.length; _i2++) {
    var _ret = _loop();

    if (typeof _ret === "object") return _ret.v;
  }

  return undefined;
}
/**
 * @internal
 */


export function setPlatformSpecificData(_x) {
  return _setPlatformSpecificData.apply(this, arguments);
}

function _setPlatformSpecificData() {
  _setPlatformSpecificData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(map) {
    var localNavigator, osPlatform, entropyValues, brand, _brand;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            localNavigator = globalThis.navigator;
            osPlatform = "unknown";

            if (!(localNavigator === null || localNavigator === void 0 ? void 0 : localNavigator.userAgentData)) {
              _context.next = 11;
              break;
            }

            _context.next = 5;
            return localNavigator.userAgentData.getHighEntropyValues(["architecture", "platformVersion"]);

          case 5:
            entropyValues = _context.sent;
            osPlatform = "".concat(entropyValues.architecture, "-").concat(entropyValues.platform, "-").concat(entropyValues.platformVersion); // Get the brand and version

            brand = getBrandVersionString(localNavigator.userAgentData.brands);

            if (brand) {
              map.set(brand.brand, brand.version);
            }

            _context.next = 12;
            break;

          case 11:
            if (localNavigator === null || localNavigator === void 0 ? void 0 : localNavigator.platform) {
              osPlatform = localNavigator.platform;
              _brand = getBrowserInfo(localNavigator.userAgent);

              if (_brand) {
                map.set(_brand.brand, _brand.version);
              }
            } else if (typeof globalThis.EdgeRuntime === "string") {
              map.set("EdgeRuntime", globalThis.EdgeRuntime);
            }

          case 12:
            map.set("OS", osPlatform);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _setPlatformSpecificData.apply(this, arguments);
}